module.exports = __webpack_public_path__ + "static/media/radio-alt.df059718.svg";